export default __webpack_public_path__ + "assets/images/icon-emoji.dcd8ebed71e27bfdd16f056c6b455d6a.svg";